//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../Components/Heading';
import HighlightInk from '../../Components/HighlightInk';

const Banner = () => {
  const { t } = useTranslation();

  return (
    <div className="about-banner">
      <div className="about-banner-content">
        <Heading
          className="about-banner-content-heading"
          title={t('bannerHeading')}
        />

        <p>{t('bannerPara1')}</p>

        <p>
          {t('bannerPara2l1')}
          <HighlightInk>{t('bannerPara2l2')}</HighlightInk>
          {t('bannerPara2l3')}
          <HighlightInk>{t('bannerPara2l4')}</HighlightInk> {t('bannerPara2l5')}
        </p>

        <p>{t('bannerPara3')}</p>
      </div>
    </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/Pages/AboutUs/Banner.js